import { isValidPhoneNumber } from './phoneNumber';

export const validateContact = (values) => {
    const errors = {};

    if (!values.PatientId) errors.PatientId = 'Required';
    else if (!/^\d+$/.test(values.PatientId))
        errors.PatientId = 'Invalid Patient Id';
    if (!values.PhoneNumber) errors.PhoneNumber = 'Required';
    else if (!isValidPhoneNumber(values.PhoneNumber))
        errors.PhoneNumber = 'Invalid Phone Number';

    return errors;
}